$(document).ready(function() {

  // DESKTOP NAV
  $('[data-dnav]').each(function() {

    var $dnav = $(this),
        $dnavSubnavs = $dnav.find('[data-dnav-sub]'),
        $dnavSubnavToggles = $dnav.find('[data-dnav-sub-toggle]');

    // prevent default behaviour of top-level links
    $dnavSubnavToggles.on('click', function(e) {
      e.preventDefault();
    });

    
    // add active class to li
    $dnavSubnavs.on('click', function() {
      if (!$(this).hasClass("is-active")) {
        // Remove the class from anything that is active
        $("li.is-active").removeClass("is-active");
        // And make this active
        $(this).addClass("is-active");
      } else {
        $(this).removeClass("is-active");
      }
    });
    
    // don't close mega-menu if you click on it
    $dnavSubnavs.children('.gheader__dnav__subnav').click(function(e) {
        e.stopPropagation();
    });
    
    // close mega-menu if clicked off
    $('body').click(function(e) {
      if ($(e.target).closest('.gheader__dnav').length === 0) {
        $("li.is-active").removeClass("is-active");
      }
    });

  });
  
  // DESKTOP NAV STICKY
  var $stickyHeader = $('.gheader__inner');
  
  createSticky($stickyHeader);
  
  function createSticky(sticky) {
	
      if (typeof sticky !== 'undefined') {

          var pos = sticky.offset().top,
              win = $(window);

          win.on('scroll', function() {
              win.scrollTop() >= pos ? $('body').addClass('mod-fixed-header') : $('body').removeClass('mod-fixed-header');      
          });			
      }
  }
  
  $(window).resize(function() {
  if ($(window).width() > 1169) {
      $('html').removeClass('no-scroll');
      $('[data-mnav]').each(function() {
        var $mnav = $(this),
            mnavOpenClass = 'is-open',
            $mnavSubnavs = $mnav.find('[data-mnav-sub]'),
            $mnavSubnavToggles = $mnav.find('[data-mnav-sub-toggle]');
        $mnav.removeClass(mnavOpenClass);
        $mnavSubnavs.removeClass(mnavOpenClass);
      });
    }
  });

  // MOBILE NAV
  $('[data-mnav]').each(function() {

    var $mnav = $(this),
        $mnavToggle = $mnav.find('[data-mnav-toggle]'),
        mnavOpenClass = 'is-open',
        $mnavSubnavs = $mnav.find('[data-mnav-sub]'),
        $mnavSubnavToggles = $mnav.find('[data-mnav-sub-toggle]'),
        $html = $('html'),
        htmlNoScrollClass = 'no-scroll';

    // toggle on click
    $mnavToggle.on('click', function(e) {
      e.preventDefault();
      $mnav.toggleClass(mnavOpenClass);

      // close subnavs when closing mnav
      if (!$mnav.hasClass(mnavOpenClass)) {
        $mnavSubnavs.removeClass(mnavOpenClass);
        $html.removeClass('no-scroll');
      } else {
        $html.addClass('no-scroll');
      }
    });

    // close when clicking elsewhere
    $(document).on('click', function (e) {
      if ($(e.target).closest($mnav).length === 0) {
        $mnav.removeClass(mnavOpenClass);
      }
    });

    // toggle subnavs
    $mnavSubnavToggles.on('click', function(e) {
      e.preventDefault();

      var $toggle = $(this),
          $parentSubnav = $toggle.parents('[data-mnav-sub]');

      $mnavSubnavs.not($parentSubnav).removeClass(mnavOpenClass); // shut others
      $parentSubnav.toggleClass(mnavOpenClass); // open target
    });
  });
  
    
 // MOBILE NAV STICKY
  var $mnavstickyHeader = $('.mnav-scroll-point');
  
  createmnavSticky($mnavstickyHeader);
  
  function createmnavSticky(sticky) {
	
      if (typeof sticky !== 'undefined') {

          var pos = sticky.offset().top,
              win = $(window);

          win.on('scroll', function() {
              win.scrollTop() >= pos ? $('body').addClass('mod-mnav-fixed-header') : $('body').removeClass('mod-mnav-fixed-header');      
          });			
      }
  }


  // SITE SWITCHER
  $('[data-switcher]').each(function() {

    var $switcher = $(this),
        $switcherToggle = $switcher.find('[data-switcher-toggle]'),
        switcherOpenClass = 'is-open';

    // toggle on click
    $switcherToggle.on('click', function(e) {
      e.preventDefault();
      $switcher.toggleClass(switcherOpenClass);
    });

    // close when clicking elsewhere
    $(document).on('click', function (e) {
      if ($(e.target).closest($switcher).length === 0) {
        $switcher.removeClass(switcherOpenClass);
      }
    });

  });

});
